import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "aemo_coal",
  "use": "aemo_coal-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"aemo_coal\"><title>aemo_coal</title><path d=\"M13.014 10.776H3.152L1.945 5.329h12.149zm2.653-6.74a.79.79 0 0 0-.611-.289h-1.104a.79.79 0 0 0 .078-.34v-.352c0-.258-.126-.5-.337-.647l-1.35-.946a.789.789 0 0 0-.643-.12l-1.509.373L7.637.528a.79.79 0 0 0-.947.219l-.834 1.027-1.139-.504a.79.79 0 0 0-.865.151l-1.026.977-.612.298a.791.791 0 0 0-.367 1.051H.958a.791.791 0 0 0-.771.961l1.557 7.028a.79.79 0 0 0 .772.619h11.146a.79.79 0 0 0 .775-.637L15.83 4.69a.79.79 0 0 0-.164-.655zM5.282 12.906a1.393 1.393 0 1 0 0 2.786 1.393 1.393 0 0 0 0-2.786zM11.08 12.906a1.393 1.393 0 1 0 0 2.786 1.393 1.393 0 0 0 0-2.786z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/aemo_coal.svg
// module id = 508
// module chunks = 0